import BeneficiaryFormConfirm from './container'

export default BeneficiaryFormConfirm
